import { makeApiCall, ApiResponse, ApiError } from "./index";

const BASE_URL = process.env.REACT_APP_API_AUTHENTICATION_URL;

// POST request
export function Login(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}users/login`, "POST", body, {
    isPublicRoute: true,
  });
}
